import React from 'react';
import WalletCardPreview from './WalletCardPreview';
import CardPreview from './CardPreview';

/** Превью 1:1 как в Telegram — обёртка .tg-app */
const TemplatePreviewsPanel = ({ user, template }) => (
  <aside className="admin-template-previews-panel">
    <p className="admin-previews-panel-title">Превью</p>
    <div className="tg-app admin-tg-preview">
      <div className="wallet admin-tg-preview-wallet">
        <WalletCardPreview user={user} template={template} />
        <CardPreview template={template} />
      </div>
    </div>
  </aside>
);

export default TemplatePreviewsPanel;
